import Image from '@components/image'
import { StyleBannerBg } from './style'
import { StyleLeftBannerWrapper, StyleRightBannerWrapper } from './style'
import BannerImg from './banner.png'
import Typography from '@components/typography'
import Button from '@components/button'
import { useSelector } from 'react-redux'
import Svg from '@components/svg'
import { useNavigate } from 'react-router-dom'
const WelcomeCard = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  return (
    <StyleBannerBg>
      <StyleLeftBannerWrapper>
        <Typography
          content={`Welcome Back,`}
          tc="primary"
          weight={500}
          size={18}
        />
        <Typography
          content={`${user?.name}`}
          tc="text"
          weight={500}
          size={18}
        />
        <Typography
          content="Good luck for a Eventful Day Ahead"
          tc="text"
          size={20}
        />
        <Button
          leftComponent={<Svg svg="appointment" color={'white'} />}
          title="View Appointment"
          height={45}
          styleButtonWrapper="margin-top:10px;"
          onClick={() => {
            navigate(`/${user?.role}/appointments`)
          }}
        />
      </StyleLeftBannerWrapper>
      <StyleRightBannerWrapper>
        <Image src={BannerImg} />
      </StyleRightBannerWrapper>
    </StyleBannerBg>
  )
}

export default WelcomeCard
